import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { AlertTriangle, X, Check } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const IcNameBanner = () => {
  const { user, api } = useAuth();
  const [icName, setIcName] = useState('');
  const [saving, setSaving] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [saved, setSaved] = useState(false);

  if (!user || user.ic_name || dismissed || saved || user.role === 'admin') return null;

  const warningCount = user.ic_name_warning_count || 0;

  const handleSave = async () => {
    if (!icName.trim()) return;
    setSaving(true);
    try {
      await api.put('/users/me/ic-name', { ic_name: icName.trim() });
      setSaved(true);
      window.location.reload();
    } catch {
      setSaving(false);
    }
  };

  return (
    <div className={`relative z-50 ${warningCount >= 2 ? 'bg-red-600/90' : warningCount >= 1 ? 'bg-yellow-600/90' : 'bg-orange-600/90'} backdrop-blur-sm border-b ${warningCount >= 2 ? 'border-red-400/30' : 'border-orange-400/30'}`} data-testid="ic-name-banner">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-3 flex-wrap">
        <AlertTriangle className="h-5 w-5 text-white shrink-0" />
        <span className="text-sm font-semibold text-white flex-1">
          {warningCount >= 2
            ? 'Utolsó figyelmeztetés! Add meg az IC neved, vagy eltávolításra kerülsz!'
            : warningCount >= 1
            ? `Figyelmeztetés (${warningCount}/2): Kérlek add meg az IC neved a weboldalon, ellenkező esetben kénytelen leszek eltávolítani a szerverről.`
            : 'Kérlek add meg az IC neved a profilodban a folytatáshoz!'
          }
        </span>
        <div className="flex items-center gap-2">
          <Input
            value={icName}
            onChange={(e) => setIcName(e.target.value)}
            placeholder="IC neved..."
            className="h-8 w-40 bg-white/20 border-white/30 text-white placeholder:text-white/60 text-sm"
            onKeyDown={(e) => e.key === 'Enter' && handleSave()}
            data-testid="ic-name-input"
          />
          <Button size="sm" onClick={handleSave} disabled={saving || !icName.trim()} className="h-8 bg-white text-black hover:bg-gray-200 font-bold text-xs px-3" data-testid="ic-name-save-btn">
            <Check className="h-3.5 w-3.5 mr-1" /> Mentés
          </Button>
        </div>
        <button onClick={() => setDismissed(true)} className="text-white/60 hover:text-white p-1" data-testid="ic-name-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default IcNameBanner;
